/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Nasz zespół Workplace Experience zajmie się teraz realizacją wniosku o prezent. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Przekazano wyrazy uznania',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Nie można utworzyć wyrazów uznania lub wysłać prezentu. Spróbuj przesłać osobne zgłoszenie na stronie <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Coś poszło nie tak',
  'team-central.give-kudos.button': 'Przekaż wyrazy uznania',
  'team-central.give-kudos.close-button.label': 'Zamknij zasobnik',
  'team-central.give-kudos.confirm-close.title': 'Potwierdź zamknięcie',
  'team-central.give-kudos.created.description.flag': 'Twoje wyrazy uznania zostały wysłane. <a>Wyświetl wyrazy uznania</a>',
  'team-central.give-kudos.created.title.flag': 'Przekazano wyrazy uznania',
  'team-central.give-kudos.creation.failed.description.flag': 'Nie można utworzyć wyrazów uznania.',
  'team-central.give-kudos.creation.failed.title.flag': 'Coś poszło nie tak',
  'team-central.give-kudos.error-icon.label': 'Błąd',
  'team-central.give-kudos.success-icon.label': 'Sukces',
  'team-central.give-kudos.unsaved.warning': 'Wprowadzone zmiany nie zostaną zapisane.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Anuluj',
  'team-central.give-kudos.unsaved.warning.close': 'Zamknij'
};